<div class="col th-p help-page content">
  <div class="content-wrapper is-clearfix">
    <div class="column help-head-name cus-cards">
      <div class="columns">
        <div class="column is-6">
          <img
            [src]="'../../../assets/images/help.png'"
            class="is-pulled-left"
          />
          <!-- <i class="fa fa-question-circle is-pulled-left"></i> -->
          <h3 class="is-marginless is-clearfix">Help Center</h3>
        </div>
        @if (isToken===null) {
        <div class="column is-6 has-text-right">
          <a class="button is-link" routerLink="">Back To Login</a>
        </div>
        }
      </div>
    </div>
    <div class="column help-content">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <div class="box">
            <div class="columns">
              <div class="column is-2 help-list">
                <ul class="reset">
                  <li><a class="active">Your Profile And Settings</a></li>
                  <li><a>Account Settings</a></li>
                  <li><a>Your Username</a></li>
                </ul>
              </div>
              <div class="column is-10 help-details">
                <div>
                  <h3>Your Profile And Settings</h3>
                  <p>Under construction</p>
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content wrapper ends -->
</div>
